import {
    createMeterReadingField,
    createMeterReadingFieldValidation,
    editMeterReadingField,
} from 'constants/FormField/createMeterReadingField'
import useFromFieldWithAccount from 'logic/useFromFieldWithAccount'

const useMetersReading = () => {
    const {
        fieldsCreate,
        fieldsEdit,
        isLoading: isLoadingAccount,
        validationSchema,
    } = useFromFieldWithAccount({
        fieldsCreate: createMeterReadingField,
        fieldsEdit: editMeterReadingField,
        validationSchema: createMeterReadingFieldValidation,
    })

    return {
        fieldsCreate,
        fieldsEdit,
        isLoading: isLoadingAccount,
        validationSchema,
    }
}

export default useMetersReading
